/**
 * Delivery Admin API key storage manager.
 * Manages the API key used to authenticate with the delivery admin API surface.
 */

const STORAGE_KEY = 'flote_delivery_api_key';

let inMemoryApiKey: string | null = null;

function getStorage(): Storage | null {
  if (typeof window === 'undefined') return null;
  return window.localStorage;
}

export const apiKeyManager = {
  getApiKey: (): string | null => {
    if (inMemoryApiKey) {
      return inMemoryApiKey;
    }
    try {
      const storage = getStorage();
      if (storage) {
        const keyFromStorage = storage.getItem(STORAGE_KEY);
        if (keyFromStorage) {
          inMemoryApiKey = keyFromStorage;
          return keyFromStorage;
        }
      }
    } catch (error) {
      console.error('Could not access storage for API key:', error);
    }
    return null;
  },

  setApiKey: (apiKey: string): void => {
    inMemoryApiKey = apiKey;
    try {
      const storage = getStorage();
      if (storage) {
        storage.setItem(STORAGE_KEY, apiKey);
      }
    } catch (error) {
      console.error('Could not set API key in storage:', error);
    }
  },

  clearApiKey: (): void => {
    inMemoryApiKey = null;
    try {
      const storage = getStorage();
      if (storage) {
        storage.removeItem(STORAGE_KEY);
      }
    } catch (error) {
      console.error('Could not clear API key from storage:', error);
    }
  },

  hasApiKey: (): boolean => {
    return apiKeyManager.getApiKey() !== null;
  },
};
